import { listAdapter } from './adapters';
import AjaxUtils from './ajaxUtils';

export const listsAPI = {
  getListsOfCompanies: async companyIds => AjaxUtils.post('/api/v1/companies/lists', { companyIds }),

  getListsOfContacts: async queryParams => {
    const url = `${envConfig.OUTBOUND_SEARCH_URL}/api/v1/lists?${queryParams}`;
    const results = await AjaxUtils.get(url, true);

    return results?.lists.map(listAdapter);
  },

  createList: async data => AjaxUtils.post('/api/v1/lists', data),

  addContactToContactListNewApi: async payload => AjaxUtils.post('/api/v1/contacts/add', payload),
};
